import React, { useState } from 'react'
import Button from '@/components/ui/button/Button'
import useIsMobileSize from '@/hooks/useIsMobileSize'
import {i18n} from "@/locale/i18n.js";

/**
 * CustomBinaryMarketBetButton - A button for custom binary markets on mobile
 * Behaves like the "Yes" button in BinaryButtons but uses Button.jsx component
 */
const CustomBinaryMarketBetButton = ({
  label = i18n('place_bet.bet'),
  hoverContent = null,
  onClick = () => {},
  isSelected = false,
  className = '',
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const isMobileSize = useIsMobileSize()

  return (
    <div
      className={`flex w-full ${className}`}
      onMouseEnter={() => !isMobileSize && setIsHovered(true)}
      onMouseLeave={() => !isMobileSize && setIsHovered(false)}
      onClick={onClick}>
      <Button
        variant="primary"
        type="solid"
        size="large"
        className={`w-full !h-12 transition-all duration-200 bg-brand-04`}
        buttonType="button">
        <div className="text-sm font-bold">
          {isHovered && hoverContent && !isMobileSize ? hoverContent : label}
        </div>
      </Button>
    </div>
  )
}

export default CustomBinaryMarketBetButton

